export interface GhgEmissionPeriod {
  id: number;
  periodStart: string;
  periodEnd: string;
  petrol95: number;
  petrol98: number;
  diesel: number;
  hvoRediesel: number;
  lpg: number;
  biomethane: number;
  electricCharging: number;
  dateCreated: string;
}

export interface GhgEmissionPeriodForm {
  periodStart: string;
  periodEnd: string;
  hvoRediesel: string;
  biomethane: string;
}

export interface GhgEmissionPeriodRequest {
  periodStart: string;
  periodEnd: string;
  hvoRediesel: number;
  biomethane: number;
}

export enum GhgEmissionPeriodSortFields {
  ID = "ID",
  PERIOD_START = "PERIOD_START",
  PERIOD_END = "PERIOD_END",
  DATE_CREATED = "DATE_CREATED"
}

export type GhgEditableField = "hvoRediesel" | "biomethane";

export const GHG_EDITABLE_FIELDS: Array<{ key: GhgEditableField; label: string }> = [
  { key: "hvoRediesel", label: "HVO ReDiesel" },
  { key: "biomethane", label: "Biometaan" }
];

export const GHG_CONSTANTS: Partial<Record<keyof GhgEmissionPeriod, number>> = {
  petrol95: 93.3,
  petrol98: 93.3,
  diesel: 95.1,
  lpg: 73.6,
  electricCharging: 0
};

export const GHG_EMISSION_COLUMNS: Array<{
  key: keyof GhgEmissionPeriod;
  label: string;
  editable: boolean;
}> = [
  { key: "petrol95", label: "Bensiin 95", editable: false },
  { key: "petrol98", label: "Bensiin 98", editable: false },
  { key: "diesel", label: "Diisel", editable: false },
  { key: "hvoRediesel", label: "HVO ReDiesel", editable: true },
  { key: "lpg", label: "LPG", editable: false },
  { key: "biomethane", label: "Biometaan", editable: true },
  { key: "electricCharging", label: "Elektrilaadimine", editable: false }
];

const SERVER_MESSAGE_TRANSLATIONS: Record<string, string> = {
  "Period overlaps an existing GHG emission period": "Periood kattub olemasoleva perioodiga.",
  "Period start must not be after period end": "Perioodi algus ei tohi olla hilisem kui lõpp."
};

export function translateServerError(error: any, fallback: string): string {
  const message = error?.response?.data?.message;
  if (!message) return fallback;

  return SERVER_MESSAGE_TRANSLATIONS[message] ?? fallback;
}

export function isValidYearMonth(value: string): boolean {
  return /^\d{4}-(0[1-9]|1[0-2])$/.test(value);
}

function isValidEmissionValue(value: string): boolean {
  return value.trim() !== "" && !isNaN(Number(value)) && Number(value) >= 0;
}

export function isFormValid(form: GhgEmissionPeriodForm): boolean {
  if (!isValidYearMonth(form.periodStart) || !isValidYearMonth(form.periodEnd)) {
    return false;
  }
  if (form.periodStart > form.periodEnd) {
    return false;
  }
  return GHG_EDITABLE_FIELDS.every(({ key }) => isValidEmissionValue(form[key]));
}
